import { useEffect } from 'react';

import useUser from '@/hooks/useUser';
import { useScript } from '@/hooks/useScript';

import { USERPILOT_TOKEN, USERPILOT_URL } from '@/constants/env';

import { useUserpilotEventHandlers } from '../hooks/useUserpilotEventHandlers';
import { getUserpilotGlobal } from '../hooks/getUserpilotGlobal';
import { useLogoutHandler } from '../hooks/useLogoutHandler';

/**
 * SetupUserpilot: Loads userpilot for authenticated users in the browser,
 * and owns userpilot functionality that needs to be run only once.
 */
export const SetupUserpilot = () => {
  const userpilot = getUserpilotGlobal();
  const { data: user, isFetched } = useUser();
  const { clearEventHandlers } = useUserpilotEventHandlers();

  useScript(USERPILOT_URL, {
    crossOrigin: undefined,
    enabled: RUNTIME_ENV === 'browser' && isFetched && user.loggedIn,
  });

  useEffect(() => {
    if (
      RUNTIME_ENV === 'browser' &&
      typeof window['userpilotSettings'] === 'undefined'
    ) {
      window['userpilotSettings'] = {
        token: USERPILOT_TOKEN,
        version: '0.822',
      };
    }
  }, []);

  useLogoutHandler(() => {
    if (typeof userpilot === 'undefined') {
      return;
    }
    console.log('Userpilot: Logout');
    clearEventHandlers();
    userpilot.destroy();
  });

  return null;
};
